/**
 * CONTRACTS §1 "Size caps", mirrored as browser-side literals.
 *
 * `@omni/shared` exports these as `LIMITS`, but SPEC §4 makes the web app a
 * **type-only** consumer of that package (a runtime import would drag zod and
 * the fs-backed jail helper into the bundle), so the two numbers the UI needs
 * are restated here. They are frozen values, and `test/limits.test.ts` asserts
 * they still equal the contract's.
 */

/** `POST /api/threads/:id/turns` body text. */
export const PROMPT_MAX_CHARS = 32_000;

/** `PUT /api/memory/claude-md`. */
export const CLAUDE_MD_MAX_BYTES = 128 * 1024;

/** Approval deny note. */
export const DENY_NOTE_MAX_CHARS = 500;
